/* pared.js · «Ponlo en tu pared». Elige póster, tamaño y fondo, y se lo pasa a model-viewer.
   El modelo de cada combinación ya está hecho a su medida real (scripts/poster_ar_glb.py), así que aquí no se
   escala nada: cambiar de tamaño es cambiar de fichero.

   La lista de pósters viaja dentro de la página (`.mp-datos`): [{handle, titulo, url, modelos: [{tamano, fondo,
   ancho_cm, alto_cm, src}]}]. Se puede entrar ya elegido: ?poster=<handle>&tamano=<46-7x70>&fondo=<negro>. */
(function () {
  var raiz = document.querySelector('[data-moa-pared]');
  if (!raiz) return;
  var datos = [];
  try { datos = JSON.parse(raiz.querySelector('.mp-datos').textContent); } catch (e) {}
  if (!datos.length) return;

  var visor = raiz.querySelector('model-viewer');
  var selPoster = raiz.querySelector('.mp-poster');
  var filaPoster = raiz.querySelector('.mp-fila-poster');
  var cajaTam = raiz.querySelector('.mp-tamanos');
  var filaFondo = raiz.querySelector('.mp-fila-fondo');
  var cajaFondo = raiz.querySelector('.mp-fondos');
  var medida = raiz.querySelector('.mp-medida');
  var sinAr = raiz.querySelector('.mp-sin-ar');
  var fallo = raiz.querySelector('.mp-fallo');
  var volver = raiz.querySelector('.mp-volver');

  var q = new URLSearchParams(location.search);
  var poster = datos.filter(function (p) { return p.handle === q.get('poster'); })[0] || datos[0];
  var clave = q.get('tamano');
  var fondo = q.get('fondo');

  function claveDe(m) { return (String(m.ancho_cm) + 'x' + String(m.alto_cm)).replace(/\./g, '-'); }
  function cm(v) { return String(v).replace('.', ','); }
  function unicos(lista) { return lista.filter(function (v, i) { return lista.indexOf(v) === i; }); }

  function chips(caja, valores, elegido, texto, alElegir) {
    caja.textContent = '';
    valores.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mp-chip';
      b.textContent = texto(v);
      b.setAttribute('aria-pressed', String(v === elegido));
      b.addEventListener('click', function () { alElegir(v); });
      caja.appendChild(b);
    });
  }

  function pintar() {
    var modelos = poster.modelos;
    var fondos = unicos(modelos.map(function (m) { return m.fondo; }).filter(Boolean));
    if (fondos.length && fondos.indexOf(fondo) < 0) fondo = fondos[0];
    if (!fondos.length) fondo = null;
    var deFondo = modelos.filter(function (m) { return (m.fondo || null) === fondo; });
    var claves = deFondo.map(claveDe);
    if (claves.indexOf(clave) < 0) {
      // Sin tamaño pedido, se abre en el Grande: es el que se ve bien en una pared sin dominarla.
      var grande = deFondo.filter(function (m) { return /grande/i.test(m.tamano); })[0];
      clave = grande ? claveDe(grande) : claves[0];
    }
    var m = deFondo[claves.indexOf(clave)];

    chips(cajaTam, claves, clave, function (k) {
      var mm = deFondo[claves.indexOf(k)];
      return mm.tamano.replace(/\s*\(([^)]+)\)\s*$/, ' · $1');
    }, function (k) { clave = k; pintar(); });
    filaFondo.hidden = !fondos.length;
    if (fondos.length) {
      chips(cajaFondo, fondos, fondo, function (f) { return 'Fondo ' + f; }, function (f) { fondo = f; pintar(); });
    }

    medida.textContent = cm(m.ancho_cm) + ' × ' + cm(m.alto_cm) + ' cm · tamaño real';
    if (visor.getAttribute('src') !== m.src) {
      fallo.hidden = true;
      // El iPhone abre su propio fichero (USDZ), anclado a pared. Sin él, Chrome de iPhone no ofrece la cámara
      // y Safari lo pondría en el suelo (model-viewer 4.3.1, lib/features/ar.js).
      if (m.ios) visor.setAttribute('ios-src', m.ios); else visor.removeAttribute('ios-src');
      visor.setAttribute('src', m.src);
      visor.setAttribute('alt', poster.titulo + ', ' + cm(m.ancho_cm) + ' × ' + cm(m.alto_cm) + ' cm');
    }
    raiz.dataset.esperado = m.ancho_cm + 'x' + m.alto_cm;
    volver.href = poster.url;
    volver.hidden = !poster.url;

    var p = new URLSearchParams(location.search);
    p.set('poster', poster.handle);
    p.set('tamano', clave);
    if (fondo) p.set('fondo', fondo); else p.delete('fondo');
    history.replaceState(null, '', location.pathname + '?' + p.toString());
  }

  filaPoster.hidden = datos.length < 2;
  datos.forEach(function (p) {
    var o = document.createElement('option');
    o.value = p.handle;
    o.textContent = p.titulo;
    selPoster.appendChild(o);
  });
  selPoster.value = poster.handle;
  selPoster.addEventListener('change', function () {
    poster = datos.filter(function (p) { return p.handle === selPoster.value; })[0] || datos[0];
    pintar();
  });

  // Lo de dentro de la cámara es de Apple o de Google y no se toca. Lo que sí se controla es lo de antes
  // (Mou, 2026-10-11: «tarda tanto en procesar que no acabas de comprender si ha habido un error»): los pasos
  // solo donde hay cámara, el botón avisa mientras se abre, y en iPhone el modelo se pide antes de tocar.
  var pasos = raiz.querySelector('.mp-pasos');
  var boton = raiz.querySelector('.mp-boton-ar');
  var textoBoton = boton.textContent;
  var espera = null;
  function restaurar() {
    clearTimeout(espera);
    boton.textContent = textoBoton;
    boton.removeAttribute('aria-busy');
  }
  boton.addEventListener('click', function () {
    boton.textContent = 'Abriendo cámara…';
    boton.setAttribute('aria-busy', 'true');
    clearTimeout(espera);
    espera = setTimeout(restaurar, 8000);
  });
  document.addEventListener('visibilitychange', restaurar);
  window.addEventListener('pagehide', restaurar);

  var ES_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var pedidos = {};
  function adelantar(url) {
    // Sin medir si Quick Look reutiliza lo que ya bajó el navegador: si no lo hace, solo se pierde esta descarga.
    if (!ES_IOS || !url || pedidos[url]) return;
    pedidos[url] = true;
    fetch(url, { cache: 'force-cache' }).catch(function () {});
  }

  // Medida comprobada sobre el modelo cargado, en centímetros: la deja a la vista de quien revise
  // (data-medido) sin enseñársela al cliente.
  visor.addEventListener('load', function () {
    var d = visor.getDimensions && visor.getDimensions();
    if (d) raiz.dataset.medido = (Math.round(d.x * 1000) / 10) + 'x' + (Math.round(d.y * 1000) / 10);
    sinAr.hidden = !!visor.canActivateAR;
    pasos.hidden = !visor.canActivateAR;
    adelantar(visor.getAttribute('ios-src'));
  });
  visor.addEventListener('error', function () { fallo.hidden = false; restaurar(); });
  visor.addEventListener('ar-status', function (e) {
    restaurar();
    if (e.detail && e.detail.status === 'failed') fallo.hidden = false;
  });

  pintar();
})();
